import {Outlet} from 'react-router-dom';
import React, {Suspense} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {useBottomSheetPage} from '@di-shared/features/common/useBottomSheetPage';
import BottomSheetLoading from '@di-shared/features/common/BottomSheetLoading';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

function BottomSheetLayout() {
  useBottomSheetPage();
  return (
    <ErrorBoundary
      fallbackRender={() => {
        window.bottomSheetClose(null);
        return null;
      }}
    >
      <Suspense
        fallback={
          <BottomSheetWebViewWrapper bottomSheetFallbackHeight={388}>
            <BottomSheetLoading />
          </BottomSheetWebViewWrapper>
        }
      >
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
}

export default BottomSheetLayout;
